"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocketClientMessage = void 0;
var SocketClientMessage;
(function (SocketClientMessage) {
    SocketClientMessage["ActiveUserCount"] = "active-user-count";
    SocketClientMessage["Match"] = "match";
    SocketClientMessage["Tournament"] = "tournament";
    SocketClientMessage["Notification"] = "notification";
    /**
     * Notify tournament players, new tournament activity (check-in, break, new game...).
     */
    SocketClientMessage["TournamentActivity"] = "tournament_activity";
    // PlatformLinking
    SocketClientMessage["LinkStatusUpdatedSuccessfully"] = "link_status_updated_successfully";
    SocketClientMessage["LinkStatusUpdateFailed"] = "link_status_update_failed";
    SocketClientMessage["LinkStatusPuuidMissing"] = "link_status_puuid_missing";
    // Tournament Match Game
    SocketClientMessage["TournamentMatchGame"] = "tournament_match_game";
    SocketClientMessage["BalanceUpdated"] = "balance_updated";
    SocketClientMessage["ExchangeRate"] = "exchange_rate";
    // User
    SocketClientMessage["User"] = "user";
    // Bracket
    SocketClientMessage["Bracket"] = "bracket";
    SocketClientMessage["TournamentMatchGameUsersStateUpdated"] = "tournament_match_game_users_state_updated";
    /**
     * Notify all users game session resource updated.
     */
    SocketClientMessage["GameSessionUpdated"] = "game_session_updated";
    /**
     * Socket client sends socket server to identify it has game session opened.
     */
    SocketClientMessage["GameSessionJoined"] = "game_session_joined";
    /**
     * Socket client sends socket server to identify it has game session spectator page opened.
     */
    SocketClientMessage["GameSessionSpectatorJoined"] = "game_session_spectator_joined";
    /**
     * Socket client sends socket server to identify it is ready for game session.
     */
    SocketClientMessage["GameSessionReady"] = "game_session_ready";
    /**
     * Server sends to clients as response to `GameSessionSpectatorReady`.
     */
    SocketClientMessage["GameSessionReadyResult"] = "game_session_ready_result";
})(SocketClientMessage = exports.SocketClientMessage || (exports.SocketClientMessage = {}));
//# sourceMappingURL=socket-client-message.js.map